var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"privacy-policy"},[_c('div',{staticClass:"container content has-text-justified",domProps:{"innerHTML":_vm._s(_vm.$t('privacy_policy'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }